import { IOrderIntV2ReferenceAction } from '@telstra-connect/order-tracker/actions/order-tracker-int-uplift/load-order-int-new';
import { IOrderTrackerState } from '@telstra-connect/order-tracker/state';

export const updateOrderReferenceLocallyReducer = (
    state: IOrderTrackerState,
    action: IOrderIntV2ReferenceAction
  ): IOrderTrackerState => {
    const { orderNumber, yourReference } = action.data;
    const updatedOrders = state.activeIntOrdersV2.data.orders.map((order) => {
      if (order.orderNumber === orderNumber) {
        return {
          ...order,
          yourReference,
        };
      }
      return order;
    });
    return {
      ...state,
      activeIntOrdersV2: {
        ...state.activeIntOrdersV2,
        data: {
          ...state.activeIntOrdersV2.data,
          orders: updatedOrders,
        },
      },
    };
  };
